import { useCallback } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import QuestionBox from '../../../question-box';
import Task304Game from './game';

type Props = {
    onComplete?: () => void
}

const Task304: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-304');

    return <div className="task task-304">
        <h2>zadanie 4</h2>
        <h3>{task?.title}</h3>
        <p>Czytając książki poznajemy świat – wraz z bohaterami odwiedzamy różne miejsca i możemy poczuć się jak podróżnicy.</p>
        <p className="instruction"><strong>Zadanie:</strong> Poniżej znajdziecie zdjęcia różnych miejsc na świecie. Dopasujcie do nich literackich bohaterów i bohaterki, dzięki którym mogliście poznać te miejsca czytając książki i podróżując w wyobraźni.</p>
        <Task304Game onComplete={onComplete} />
        <QuestionBox>
            <p>
            Graliście w poprzedniej edycji Nocy Bibliotek w grę "Klimat na czytanie"? Jeśli nie - bardzo ją polecamy. Konieczność walki o ochronę Ziemi niestety nie straciła aktualności, rzetelna wiedza o skutkach zmian klimatu jest bardzo ważna. A do tego korzystanie z biblioteki jest naprawdę eko!<br />
            Link do gry: <a href='https://nocbibliotek.ceo.org.pl/gra2020/' target='_blank'>https://nocbibliotek.ceo.org.pl/gra2020/</a>
            </p>
        </QuestionBox>
    </div>
}

export default Task304;
